<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="bankSelected"
    :clearable="!unclearable"
    :items="bankItems"
    :loading="bankLoading"
    :label="noLabel ? '' : label ? label : $t('SubAccount.Fields.bank')"
    :search-input.sync="bankSearch"
    item-text="bank_name"
    item-value="bank_code"
    item-disabled="disabled"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :disabled="disabled"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  ></v-autocomplete>
</template>

<script>
import SubAccount from "@/api/sub_accounts";

export default {
  name: "SearcherBank",

  props: {
    value: Object,
    noLabel: Boolean,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    label: String,
    disabled:Boolean
  },

  computed: {
    bankItems() {
      return this.bank.map((c) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find((disabledItem) => disabledItem.id == c.id)
          : false;
        return Object.assign({}, c, { disabled });
      });
    },
  },

  data: () => ({
    bank: [],
    bankLoading: false,
    bankSearch: "",
    bankSelected: null,
  }),
  mounted() {
    this.bankLoading = true;
    SubAccount.fetchBankSelect()
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            var bank = response.data.banks;
            var Items = [];
            for (let key in bank) {
              Items.push(
                Object.assign(
                  {},
                  {},
                  {
                    bank_code: key,
                    bank_name: bank[key],
                  }
                )
              );
            }
            this.bank = Items;
          }
          this.bankLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.bankLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.bankSelected = this.value;
      },
    },
    bankSelected: {
      handler() {
        this.$emit("input", this.bankSelected);
      },
    },
  },
};
</script>